import { type CSSProperties, memo } from "react"

import { SidebarLinkData } from "./SidebarLink"
import { SidebarNav, type SidebarNavProps } from "./SidebarNav"
import { pwaVersion } from "~/shared/config"
import { cx } from "classix"

import cssModule from "./index.module.scss"
import { Href } from "~/shared/ui"
import { useMediaQuery } from "react-responsive"
import { breakPoints } from "~/shared/ui/constants"

export type SidebarProps = {
	enableTransition: boolean,
	hide: boolean
	links: SidebarLinkData[]
	backUrl: string
	onDarkAreaClick?: () => void
	customization: {
		style?: CSSProperties
		className?: string
	} & SidebarNavProps["customization"]
	logoUrl: string
	logoText: string,
	onLogoClick?: () => void,
}

export const Sidebar = memo(function Sidebar({
												 links,
												 customization,
												 hide,
												 onDarkAreaClick,
												 logoText,
												 logoUrl,
												 enableTransition,
												 onLogoClick
											 }: SidebarProps) {

	const isSmallDevice = useMediaQuery({ maxWidth: breakPoints.sm })


	return (
		<>
			<div className={cx(cssModule.sidebarBGDarkArea, !hide && cssModule.showSidebarBGDarkArea)}
				 onClick={onDarkAreaClick} />
			<aside
				className={cx(cssModule.sidebar,
					hide && cssModule.hide,
					enableTransition && cssModule.transition,
					customization.className)}
				style={customization.style}>
				{isSmallDevice && <Href href={logoUrl} style={{
					marginTop: "0.55rem",
					textAlign: "center",
					color: "white",
					textDecoration: "none"
				}} onClick={onLogoClick}>
					<h1>
						{logoText}
					</h1>
				</Href>}
				<SidebarNav
					links={links}
					/*backUrl={backUrl}*/
					customization={customization}
				/>
				<div className={cssModule.pwaVersion}>
					{pwaVersion}
				</div>
			</aside>
		</>
	)
})
